import { v4 } from 'uuid'
import { isNotNullOrUndefinedOrEmpty } from '../../util/Utils'
import { capitalizeFirstLetter } from '../../util/StringUtil'

export default () => {}

export function makeFactConclusion(
  type,
  originalDate,
  standardDate,
  originalPlace,
  standardPlaceID,
  changeMessage,
  conclusionId
) {
  const factConclusion = {
    conclusionType: 'FACT',
    conclusionId,
    attribution: {
      changeMessage,
    },
    value: {
      type: type.includes('http://gedcomx.org/')
        ? type
        : `http://gedcomx.org/${capitalizeFirstLetter(type.toLowerCase())}`,
    },
  }
  if (isNotNullOrUndefinedOrEmpty(originalDate)) {
    const date = {
      original: originalDate,
    }
    if (isNotNullOrUndefinedOrEmpty(standardDate)) {
      date.normalized = [{ value: standardDate, lang: null }]
    }
    factConclusion.value.date = date
  }
  if (isNotNullOrUndefinedOrEmpty(originalPlace)) {
    const place = {
      original: originalPlace,
    }
    if (isNotNullOrUndefinedOrEmpty(standardPlaceID)) {
      place.id = standardPlaceID
    }
    factConclusion.value.place = place
  }
  return factConclusion
}

export function makeNewConclusion(
  conclusionType,
  valueType,
  originalDate,
  standardDate,
  originalPlace,
  standardPlaceID,
  changeMessage
) {
  const conclusion = makeNewEmptyConclusion()
  conclusion.conclusionType = conclusionType
  conclusion.value.date.original = originalDate
  conclusion.value.date.normalized[0].value = standardDate
  conclusion.value.place.original = originalPlace
  conclusion.value.place.id = standardPlaceID
  if (valueType) {
    conclusion.value.type = valueType.includes('http://gedcomx.org/')
      ? valueType
      : `http://gedcomx.org/${capitalizeFirstLetter(valueType.toLowerCase())}`
  }
  conclusion.attribution = {
    changeMessage,
  }
  return conclusion
}

export function makeNewEmptyConclusion() {
  return {
    conclusionId: v4(),
    value: {
      type: '',
      date: makeNewDateConclusion(),
      place: makeNewPlaceConclusion(),
    },
  }
}

export function makeNewDateConclusion(originalDate, standardDate) {
  return {
    original: originalDate || standardDate || '',
    normalized: [
      {
        lang: 'en-US',
        value: standardDate || '',
      },
    ],
  }
}

export function makeNewPlaceConclusion(originalPlace, standardPlace, standardPlaceId) {
  return {
    id: standardPlaceId || undefined,
    original: originalPlace || standardPlace || '',
    names: [
      {
        lang: 'en-US',
        value: standardPlace,
      },
    ],
  }
}
